import {
  Avatar,
  Button,
  Divider,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import getUserAvatar from "../../helpers/getUserAvatar";
import { signOut } from "../../state/actions/user";
import { trackUserProfileDropdownAction } from "../../helpers/analytics";
import useQueryPreservingNavigate from "../../helpers/useQueryPreservingNavigate";
import { useLocation } from "@reach/router";
import useGetPageByRole from "../../helpers/useGetPageByRole";

const MobileProfile = ({ setDrawer }) => {
  const theme = useTheme();
  const allPoints = useSelector((state) => state.user?.points?.all);
  const email = useSelector((state) => state.user?.email);
  const profile = useSelector((state) => state.user.profile);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useQueryPreservingNavigate();
  const location = useLocation();
  const pageByRole = useGetPageByRole();

  const avatarSrc = useMemo(() => {
    return getUserAvatar(allPoints);
  }, [allPoints]);

  const fullName = useMemo(() => {
    const firstName = profile?.firstname || "";
    const lastName = profile?.lastname || "";

    return `${firstName} ${lastName}`;
  }, [profile]);

  const handleNavigation = (path, actionId) => {
    trackUserProfileDropdownAction(actionId);
    navigate(pageByRole);
    setDrawer(false);
  };

  const handleSignOut = () => {
    dispatch(signOut(user, location.search));
  };

  return (
    <Stack sx={{ backgroundColor: theme.palette.primary.main, flexGrow: 1 }}>
      <Stack direction="row" sx={{ alignItems: "center", p: "20px" }} gap={1}>
        <Avatar
          src={avatarSrc}
          sx={{
            width: "41px",
            height: "41px",
          }}
        />

        <Stack>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "16px",
              color: "#ffffff",
            }}
          >
            {fullName}
          </Typography>

          <Typography
            component="span"
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              textAlign: "right",
              color: "#ffffff",
              width: "150px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {email}
          </Typography>
        </Stack>
      </Stack>

      <Divider sx={{ borderColor: "#ffffff" }} />

      <Stack sx={{ p: "20px" }} gap={1}>
        <Button
          variant="outlined"
          sx={{
            borderRadius: "26px",
            borderColor: "#ffffff",
            backgroundColor: "#ffffff",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              color: "#ffffff",
              borderColor: "#ffffff",
            },
          }}
          onClick={() => handleNavigation("settings", "Profile Settings")}
        >
          See profile
        </Button>

        <Button sx={{ color: "#ffffff" }} onClick={handleSignOut}>
          Sign out
        </Button>
      </Stack>
    </Stack>
  );
};

export default MobileProfile;
